import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import DataTable from 'shared/components/table/DataTable';
import { searchTickets } from 'shared/api/support';
import { CardSection } from 'shared/components/cardControls';
import { defaultSearch } from 'shared/utils';
import { FILTER_DISPLAY_TYPE, VARIANTS } from 'shared/constants';
import { getTicketSubjectPath } from 'shared/routes/support';
import { FilterRedirect } from 'shared/hoc/withFilters';
import { ticketColumns } from 'shared/components/table/ticketColumns';
import { TICKET_STATUS_OPTIONS } from 'shared/constants/support';
import { withStaticSelect } from 'shared/components/data-display/withSelectors';
import { Section } from 'shared/components/styled/layouts';

const tenantFilters = [
  {
    label: 'Status',
    param: 'status',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withStaticSelect({
      options: TICKET_STATUS_OPTIONS,
    }),
  },
];

/**
 * @param {Object} props
 * @param {Object} props.tenantState - Tenant state object
 * @param {string} props.path - Path string
 * @param {string} props.savedFilters - Saved filters string
 * @param {string} props.filterKey - Filter key string
 */
export default function TenantTickets(props) {
  const { search } = useLocation();

  const {
    tenantState: {
      building,
      data: { id: tenantId },
    },
    path,
    savedFilters,
    filterKey,
  } = props;

  const baseSearch = useMemo(() => defaultSearch(
    search,
    {
      tenant_id: tenantId,
    },
  ), [tenantId, search]);

  if (!FilterRedirect(path, savedFilters)) {
    return (
      <CardSection>
        <Section>
          <DataTable
            noSearchForm
            noExportButton
            filters={tenantFilters}
            filterKey={filterKey}
            columns={ticketColumns}
            searchRequest={searchTickets}
            baseSearch={baseSearch}
            className="table-height-md"
            rowId="id"
          />
          <div style={{
            paddingTop: 10,
            textAlign: 'right',
          }}
          >
            <Button
              href={getTicketSubjectPath(building?.id, building?.unit?.id, tenantId)}
              variant="contained"
              color={VARIANTS.primary}
              target="_blank"
              disabled={!(building?.id && building?.unit?.id)}
            >
              Create Ticket
            </Button>
          </div>
        </Section>
      </CardSection>
    );
  }
}
